<template lang="pug">
  .inicio-main-dash.inicio-main-dash-prestamo-vida

    .prestamo-vida-header(v-if="$vuetify.breakpoint.smAndDown")
      v-btn(icon @click="goBack" color="white")
        v-icon arrow_back
      span.prestamo-vida-header-title Préstamos

    //- Desktop: panel grande (pólizas + Disponible hoy) | info derecha
    .inicio-panel.prestamo-vida-polizas-panel.mt-2.border-radius-top.panel-full-height.hidden-sm-and-down
      h2.title-main Selecciona un seguro
      .prestamo-vida-panel-body
        .prestamo-vida-lista
          p.text-instruction Revisa cuánto puedes solicitar y, si tienes un préstamo en evaluación o vigente, consulta aquí todos los detalles.
          div.list-container(v-if="loadingPolizas")
            p.text-center.omnesRegular(style="padding: 24px; color: #64748B;") Cargando pólizas...
          div.list-container(v-else-if="polizasDisponibles.length === 0")
            p.text-center.omnesRegular(style="padding: 24px; color: #64748B;") No tienes préstamos disponibles en este momento.
          div.list-container(v-else)
            v-layout.polizas.g-align-center(row wrap v-for="(poliza, index) in polizasDisponibles" :key="'d-' + poliza.policyNumber" @click.stop="goToPrestamo(poliza)")
              v-flex(xs1 md1 lg1)
              v-flex(xs3 md3 lg3)
                v-img(:src="productsIcons[poliza.image]" style="width: 80px;")
              v-flex(xs7 md7 lg7)
                v-card-title.omnesMedium(primary style="padding-bottom: 0px; padding-top: 8px; font-size: 16px; line-height: 1.2;") {{ poliza.name === 'Vida Cash' ? 'Vida con Devolución' : poliza.name }}
                v-card-text.omnesRegular(style="padding-bottom: 0; padding-top: 4px;")
                  span(style="color: #40C2A6; font-size: 12px;")
                    | Disponible&nbsp;
                    span(style="font-weight: 600; color: inherit;") hasta:&nbsp;{{ formatMonto(poliza.montos) }}
                v-card-text.omnesRegular.numeroPoliza(style="padding-top: 4px; padding-bottom: 8px; font-size: 13px;")
                  span(style="color: #00ADEE;") N° de póliza:&nbsp;
                  | {{ poliza.policyNumber }}
              v-flex(xs1 md1 lg1)
                svg(width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg")
                  path(d="M9.31002 6.70978C9.21732 6.80229 9.14377 6.91218 9.09359 7.03315C9.04341 7.15413 9.01758 7.28381 9.01758 7.41478C9.01758 7.54575 9.04341 7.67543 9.09359 7.7964C9.14377 7.91738 9.21732 8.02726 9.31002 8.11978L13.19 11.9998L9.31002 15.8798C9.12304 16.0668 9.018 16.3203 9.018 16.5848C9.018 16.8492 9.12304 17.1028 9.31002 17.2898C9.497 17.4768 9.7506 17.5818 10.015 17.5818C10.2794 17.5818 10.533 17.4768 10.72 17.2898L15.31 12.6998C15.4027 12.6073 15.4763 12.4974 15.5265 12.3764C15.5766 12.2554 15.6025 12.1257 15.6025 11.9948C15.6025 11.8638 15.5766 11.7341 15.5265 11.6132C15.4763 11.4922 15.4027 11.3823 15.31 11.2898L10.72 6.69978C10.34 6.31978 9.70002 6.31978 9.31002 6.70978Z" fill="#0855C4")
        .prestamo-vida-monto-panel(v-if="polizaSeleccionada && !loadingPolizas")
          h4.omnesMedium.text-center(style="color: #4A4A4A; font-weight: normal; font-size: 16px; margin-bottom: 24px;") Disponible hoy
          .d-flex.align-center.justify-center(style="margin-bottom: 35px;")
            img(src="../assets/prestamos-vida/flat-icons-money-transfer.svg" style="height: 36px; margin-left: -16px; margin-right: -24px;")
            span.omnesSemibold(style="color: #0855C4; font-size: 25px; line-height: 1;") {{ formatMonto(polizaSeleccionada.montos) }}
          v-btn.omnesMedium.prestamo-vida-btn-primary(block dark :disabled="!canSolicitar" style="border-radius: 8px; text-transform: none; font-size: 16px; height: 50px; box-shadow: none;" @click="goSolicitud") Solicitar préstamo

    .inicio-extra.hidden-sm-and-down
      section
        figure.d-flex.align-center.justify-center(style="margin-top:40px;")
          img(src="../assets/prestamos-vida/img-info-prestamos-vida.svg")

    //- Mobile: lista vertical → al elegir, carrusel peek (mismas cards)
    .prestamo-vida-mobile.hidden-md-and-up
      template(v-if="!showMobilePeekCarousel")
        h2.title-main Selecciona un seguro
        p.text-instruction Revisa cuánto puedes solicitar y, si tienes un préstamo en evaluación o vigente, consulta aquí todos los detalles.
      div.list-container(v-if="loadingPolizas")
        p.text-center.omnesRegular(style="padding: 24px; color: #64748B;") Cargando pólizas...
      div.list-container(v-else-if="polizasDisponibles.length === 0")
        p.text-center.omnesRegular(style="padding: 24px; color: #64748B;") No tienes préstamos disponibles en este momento.
      //- Lista vertical (sin selección o una sola póliza)
      div.list-container(v-else-if="!showMobilePeekCarousel")
        v-layout.polizas.g-align-center(
          row wrap
          v-for="(poliza, index) in polizasDisponibles"
          :key="'m-' + poliza.policyNumber"
          :class="{ 'prestamo-vida-poliza-active': isPolizaSeleccionada(poliza) }"
          @click.stop="goToPrestamo(poliza)"
        )
          v-flex(xs1 md1 lg1)
          v-flex(xs3 md3 lg3)
            v-img(:src="productsIcons[poliza.image]" style="width: 80px;")
          v-flex(xs7 md7 lg7)
            v-card-title.omnesMedium(primary style="padding-bottom: 0px; padding-top: 8px; font-size: 16px; line-height: 1.2;") {{ poliza.name === 'Vida Cash' ? 'Vida con Devolución' : poliza.name }}
            v-card-text.omnesRegular(style="padding-bottom: 0; padding-top: 4px;")
              span(style="color: #40C2A6; font-size: 12px;")
                | Disponible&nbsp;
                span(style="font-weight: 600; color: inherit;") hasta:&nbsp;{{ formatMonto(poliza.montos) }}
            v-card-text.omnesRegular.numeroPoliza(style="padding-top: 4px; padding-bottom: 8px; font-size: 13px;")
              span(style="color: #00ADEE;") N° de póliza:&nbsp;
              | {{ poliza.policyNumber }}
          v-flex(xs1 md1 lg1)
            svg(width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg")
              path(d="M9.31002 6.70978C9.21732 6.80229 9.14377 6.91218 9.09359 7.03315C9.04341 7.15413 9.01758 7.28381 9.01758 7.41478C9.01758 7.54575 9.04341 7.67543 9.09359 7.7964C9.14377 7.91738 9.21732 8.02726 9.31002 8.11978L13.19 11.9998L9.31002 15.8798C9.12304 16.0668 9.018 16.3203 9.018 16.5848C9.018 16.8492 9.12304 17.1028 9.31002 17.2898C9.497 17.4768 9.7506 17.5818 10.015 17.5818C10.2794 17.5818 10.533 17.4768 10.72 17.2898L15.31 12.6998C15.4027 12.6073 15.4763 12.4974 15.5265 12.3764C15.5766 12.2554 15.6025 12.1257 15.6025 11.9948C15.6025 11.8638 15.5766 11.7341 15.5265 11.6132C15.4763 11.4922 15.4027 11.3823 15.31 11.2898L10.72 6.69978C10.34 6.31978 9.70002 6.31978 9.31002 6.70978Z" fill="#0855C4")
      //- Carrusel peek: mismas cards, track horizontal
      .prestamo-vida-peek-track(
        v-else
        ref="peekTrack"
        @scroll.passive="onPeekScroll"
      )
        v-layout.polizas.prestamo-vida-peek-item.g-align-center(
          row wrap
          v-for="(poliza, index) in polizasDisponibles"
          :key="'peek-' + poliza.policyNumber"
          :data-policy-number="poliza.policyNumber"
          :class="{ 'prestamo-vida-poliza-active': isPolizaSeleccionada(poliza) }"
          @click.stop="goToPrestamo(poliza)"
        )
          v-flex(xs1 md1 lg1)
          v-flex(xs3 md3 lg3)
            v-img(:src="productsIcons[poliza.image]" style="width: 80px;")
          v-flex(xs7 md7 lg7)
            v-card-title.omnesMedium(primary style="padding-bottom: 0px; padding-top: 8px; font-size: 16px; line-height: 1.2;") {{ poliza.name === 'Vida Cash' ? 'Vida con Devolución' : poliza.name }}
            v-card-text.omnesRegular(style="padding-bottom: 0; padding-top: 4px;")
              span(style="color: #40C2A6; font-size: 12px;")
                | Disponible&nbsp;
                span(style="font-weight: 600; color: inherit;") hasta:&nbsp;{{ formatMonto(poliza.montos) }}
            v-card-text.omnesRegular.numeroPoliza(style="padding-top: 4px; padding-bottom: 8px; font-size: 13px;")
              span(style="color: #00ADEE;") N° de póliza:&nbsp;
              | {{ poliza.policyNumber }}
          v-flex(xs1 md1 lg1)
            svg(width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg")
              path(d="M9.31002 6.70978C9.21732 6.80229 9.14377 6.91218 9.09359 7.03315C9.04341 7.15413 9.01758 7.28381 9.01758 7.41478C9.01758 7.54575 9.04341 7.67543 9.09359 7.7964C9.14377 7.91738 9.21732 8.02726 9.31002 8.11978L13.19 11.9998L9.31002 15.8798C9.12304 16.0668 9.018 16.3203 9.018 16.5848C9.018 16.8492 9.12304 17.1028 9.31002 17.2898C9.497 17.4768 9.7506 17.5818 10.015 17.5818C10.2794 17.5818 10.533 17.4768 10.72 17.2898L15.31 12.6998C15.4027 12.6073 15.4763 12.4974 15.5265 12.3764C15.5766 12.2554 15.6025 12.1257 15.6025 11.9948C15.6025 11.8638 15.5766 11.7341 15.5265 11.6132C15.4763 11.4922 15.4027 11.3823 15.31 11.2898L10.72 6.69978C10.34 6.31978 9.70002 6.31978 9.31002 6.70978Z" fill="#0855C4")
      .prestamo-vida-monto-mobile(v-if="polizaSeleccionada && !loadingPolizas")
        v-card.disponible-hoy-card(elevation="3" style="background: #F1F1F1; border-radius: 12px; width: 100%; padding: 24px; box-shadow: 0 2px 8px rgba(0,0,0,0.1); border: 1px solid #E2E8F0;")
          h4.omnesMedium.disponible-hoy-title.text-center Disponible hoy
          .d-flex.align-center.justify-center.disponible-hoy-monto-row
            img.disponible-hoy-icon(src="../assets/prestamos-vida/flat-icons-money-transfer.svg" alt="")
            span.omnesSemibold.disponible-hoy-amount {{ formatMonto(polizaSeleccionada.montos) }}
          v-btn.omnesMedium.prestamo-vida-btn-primary(block dark :disabled="!canSolicitar" style="border-radius: 8px; text-transform: none; font-size: 16px; height: 50px; box-shadow: none;" @click="goSolicitud") Solicitar préstamo

    PopupSolicitudEnCurso(
      :openPopup="showModalSolicitudEnCurso"
      @close="cerrarSolicitudEnCurso"
    )
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { showPrestamosVidaErrorAlert } from '@/utils/prestamosVidaAlertUtil'
import PopupSolicitudEnCurso from '@/components/modals/prestamos-vida/PopupSolicitudEnCurso.vue'

export default {
  name: 'PrestamoVida',
  components: {
    PopupSolicitudEnCurso
  },
  data () {
    return {
      polizasDisponibles: [],
      polizaSeleccionada: null,
      loadingPolizas: false,
      showModalSolicitudEnCurso: false,
      _peekScrollTimer: null,
      _peekScrollLock: false,
      productsIcons: {
        'educacion_garantizada': require('@/assets/products/educacion-garantizada.svg'),
        'vida': require('@/assets/products/vida.svg'),
        'masivos': require('@/assets/products/seguro-vehicular.svg'),
        'seguro_vehicular': require('@/assets/products/seguro-vehicular.svg'),
        'seguro_vehicular_modular': require('@/assets/products/seguro-vehicular.svg')
      }
    }
  },
  computed: {
    ...mapGetters('user', ['polizasInfo', 'prestamosVidaDisponibilidad']),
    /**
     * Habilita la solicitud solo si la póliza seleccionada tiene un monto máximo utilizable.
     * @returns {boolean}
     */
    canSolicitar () {
      if (!this.polizaSeleccionada || !this.polizaSeleccionada.montos) return false
      return this.parseMonto(this.polizaSeleccionada.montos.montoMaximo) > 0
    },
    /**
     * Mobile: carrusel peek solo con selección y más de una póliza.
     * @returns {boolean}
     */
    showMobilePeekCarousel () {
      return !!(
        this.$vuetify.breakpoint.smAndDown &&
        this.polizaSeleccionada &&
        this.polizasDisponibles.length > 1
      )
    }
  },
  watch: {
    showMobilePeekCarousel (enabled) {
      if (!enabled) return
      this.$nextTick(() => {
        this.scrollPeekToSelected(false)
      })
    }
  },
  methods: {
    ...mapActions('user', ['getPolizasVidaVehicular', 'getPrestamosVidaDisponibilidad']),
    sortByName (a, b) {
      if (a.name > b.name) { return 1 }
      if (a.name < b.name) { return -1 }
      return 0
    },
    /**
     * Indica si la póliza es la seleccionada actualmente.
     * @param {Object} poliza
     * @returns {boolean}
     */
    isPolizaSeleccionada (poliza) {
      if (!this.polizaSeleccionada || !poliza) return false
      return this.polizaSeleccionada.policyNumber === poliza.policyNumber
    },
    getSimboloMoneda (moneda) {
      if (!moneda) return 'S/'
      const m = moneda.toLowerCase()
      if (m.includes('dolar') || m.includes('dólar') || m.includes('usd')) return '$'
      return 'S/'
    },
    parseMonto (valor) {
      if (valor === null || valor === undefined || valor === '') return NaN
      const normalizado = String(valor).replace(/,/g, '')
      return parseFloat(normalizado)
    },
    formatMonto (montos) {
      if (!montos || !montos.montoMaximo) return '—'
      const simbolo = this.getSimboloMoneda(montos.moneda)
      const valor = this.parseMonto(montos.montoMaximo)
      if (isNaN(valor)) return simbolo + ' ' + montos.montoMaximo
      return simbolo + ' ' + valor.toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    buildPolizaFromItem (item, montosItem) {
      const nameOri = item.producto.toLowerCase().split(' ').join('_')
      const ramo = item.ramo.toLowerCase().split(' ').join('_')
      let image = 'vida'
      if (nameOri !== '' && (!this.productsIcons[nameOri] || this.productsIcons[nameOri] === null) && (this.productsIcons[ramo] || this.productsIcons[ramo] !== null)) {
        image = (nameOri === 'educacion_garantizada') ? nameOri : ramo
      }
      return {
        policyNumber: item.numeroPoliza,
        name: item.producto,
        nameOri,
        image,
        ramo: item.ramo,
        oriProducto: item.oriProducto,
        prestamoDisponible: true,
        montos: {
          codigoRespuesta: montosItem.codigoRespuesta,
          mensajeRespuesta: montosItem.mensajeRespuesta,
          numeroPoliza: montosItem.numeroPoliza,
          moneda: montosItem.moneda,
          montoMinimo: montosItem.montoMinimo,
          montoMaximo: montosItem.montoMaximo,
          saldoValorGarantia: montosItem.saldoValorGarantia,
          porcentajeSumaAsegurada: montosItem.porcentajeSumaAsegurada,
          interesPrestamo: montosItem.interesPrestamo,
          tea: montosItem.tea
        }
      }
    },
    aplicarDisponibilidad (policies, disponibilidad) {
      if (!disponibilidad || !disponibilidad.polizas) {
        this.polizasDisponibles = []
        return
      }

      const elegibles = disponibilidad.polizas.filter(p => p.prestamoDisponible)
      const polizasDisponibles = []

      elegibles.forEach(montosItem => {
        const item = policies.find(p => p.numeroPoliza === montosItem.numeroPoliza)
        if (item) {
          polizasDisponibles.push(this.buildPolizaFromItem(item, montosItem))
        }
      })

      this.polizasDisponibles = polizasDisponibles.sort(this.sortByName)
      if (this.polizasDisponibles.length === 1) {
        this.polizaSeleccionada = this.polizasDisponibles[0]
      } else {
        this.polizaSeleccionada = null
      }
    },
    cargarDisponibilidad (policies) {
      const numerosPoliza = policies
        .filter(f => f.ramo === 'Vida')
        .map(p => p.numeroPoliza)

      if (numerosPoliza.length === 0) {
        this.loadingPolizas = false
        this.polizasDisponibles = []
        return Promise.resolve()
      }

      const tieneCache = !!(this.prestamosVidaDisponibilidad && this.prestamosVidaDisponibilidad.polizas)
      if (tieneCache) {
        if (this.prestamosVidaDisponibilidad.tieneSolicitudEnEvaluacion) {
          this.bloquearPorSolicitudEnCurso()
        } else {
          this.aplicarDisponibilidad(policies, this.prestamosVidaDisponibilidad)
        }
      } else {
        this.loadingPolizas = true
      }

      return this.getPrestamosVidaDisponibilidad()
        .then(res => {
          const data = res.data
          if (data && data.tieneSolicitudEnEvaluacion) {
            this.bloquearPorSolicitudEnCurso()
            return
          }
          if (!data || data.codigoRespuesta !== '01' || !data.prestamoVidaHabilitado) {
            if (!tieneCache) {
              this.polizasDisponibles = []
              this.$router.replace('/inicio')
            }
            return
          }
          this.aplicarDisponibilidad(policies, data)
        })
        .catch(() => {
          if (!tieneCache) {
            this.polizasDisponibles = []
            this.$router.replace('/inicio')
          }
        })
        .finally(() => {
          this.loadingPolizas = false
        })
    },
    bloquearPorSolicitudEnCurso () {
      this.polizasDisponibles = []
      this.polizaSeleccionada = null
      this.showModalSolicitudEnCurso = true
    },
    cerrarSolicitudEnCurso () {
      this.showModalSolicitudEnCurso = false
      this.$router.replace('/inicio')
    },
    getPolizasCustomer () {
      this.loadingPolizas = true
      const callback = (policies) => {
        this.cargarDisponibilidad(policies)
      }

      if (!this.polizasInfo || this.polizasInfo === null) {
        this.getPolizasVidaVehicular().then(res => {
          callback(res.data.polizas)
        }).catch(() => {
          this.loadingPolizas = false
          showPrestamosVidaErrorAlert(this, 'No se pudieron cargar las pólizas.')
        })
      } else {
        callback(this.polizasInfo)
      }
    },
    goToPrestamo (poliza) {
      this.polizaSeleccionada = poliza
      if (this.polizasDisponibles.length > 1 && this.$vuetify.breakpoint.smAndDown) {
        this.$nextTick(() => {
          this.scrollPeekToSelected(true)
        })
      }
    },
    /**
     * Alinea el track peek a la póliza seleccionada.
     * @param {boolean} smooth
     */
    scrollPeekToSelected (smooth) {
      const track = this.$refs.peekTrack
      if (!track || !this.polizaSeleccionada) return
      const el = track.querySelector(
        `[data-policy-number="${this.polizaSeleccionada.policyNumber}"]`
      )
      if (!el) return
      this._peekScrollLock = true
      el.scrollIntoView({
        inline: 'start',
        block: 'nearest',
        behavior: smooth ? 'smooth' : 'auto'
      })
      setTimeout(() => {
        this._peekScrollLock = false
      }, smooth ? 350 : 50)
    },
    /**
     * Debounce del scroll del carrusel peek para sincronizar selección.
     */
    onPeekScroll () {
      if (this._peekScrollLock) return
      if (this._peekScrollTimer) clearTimeout(this._peekScrollTimer)
      this._peekScrollTimer = setTimeout(() => {
        this.syncPeekSelectionFromScroll()
      }, 80)
    },
    /**
     * Actualiza polizaSeleccionada según la card más cercana al inicio del track.
     */
    syncPeekSelectionFromScroll () {
      const track = this.$refs.peekTrack
      if (!track || !this.showMobilePeekCarousel) return
      const items = track.querySelectorAll('.prestamo-vida-peek-item')
      if (!items.length) return
      const first = items[0]
      const gap = 12
      const step = first.offsetWidth + gap
      if (step <= 0) return
      const index = Math.min(
        items.length - 1,
        Math.max(0, Math.round(track.scrollLeft / step))
      )
      const poliza = this.polizasDisponibles[index]
      if (!poliza) return
      if (this.isPolizaSeleccionada(poliza)) return
      this.polizaSeleccionada = poliza
    },
    goSolicitud () {
      if (!this.canSolicitar) return
      this.$router.push({
        name: 'PrestamoVidaSolicitud',
        params: {
          poliza: this.polizaSeleccionada,
          montos: this.polizaSeleccionada.montos
        },
        query: {
          numeroPoliza: this.polizaSeleccionada.policyNumber
        }
      })
    },
    goBack () {
      if (
        this.$vuetify.breakpoint.smAndDown &&
        this.polizaSeleccionada &&
        this.polizasDisponibles.length > 1
      ) {
        this.polizaSeleccionada = null
        return
      }
      this.$router.push('/inicio')
    },
    /**
     * Al entrar a Préstamos Vida, vuelve el viewport arriba (evita heredar el scroll del Home).
     */
    resetScrollToTop () {
      window.scrollTo(0, 0)
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
    }
  },
  beforeDestroy () {
    if (this._peekScrollTimer) clearTimeout(this._peekScrollTimer)
  },
  mounted () {
    this.resetScrollToTop()
    this.getPolizasCustomer()
  }
}
</script>

<style scoped>
/* Mismo patrón que Home: var(--fuchsia-color) */
.prestamo-vida-btn-primary {
  background: var(--fuchsia-color) !important;
  color: #fff !important;
}

.prestamo-vida-btn-primary.v-btn--disabled {
  background: #EAEAEA !important;
  color: #9CA3AF !important;
}

.prestamo-vida-header {
  background-color: #0855C4;
  display: flex;
  align-items: center;
  padding: 12px 16px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  height: 56px;
}

.prestamo-vida-header-title {
  color: white;
  font-family: 'Omnes Medium', sans-serif;
  font-size: 18px;
  margin-left: 16px;
}

/* Mobile: fondo/stack como antes (sin heredar PaymentQuotes) */
.prestamo-vida-mobile {
  width: 100%;
  background: #fff;
  min-height: 100vh;
  padding: 16px;
  box-sizing: border-box;
}

.prestamo-vida-monto-mobile {
  display: flex;
  justify-content: center;
  margin-top: 24px;
  width: 100%;
}

/* Figma ref. 414px: bloque 356x201, centrado (misma X izquierda que el card peek) */
.prestamo-vida-monto-mobile .disponible-hoy-card {
  width: 356px;
  max-width: 356px;
  min-height: 201px;
  box-sizing: border-box;
}

.prestamo-vida-monto-mobile .disponible-hoy-title {
  color: #4A4A4A;
  font-weight: normal;
  font-size: 20px;
  margin-bottom: 24px;
}

.prestamo-vida-monto-mobile .disponible-hoy-monto-row {
  margin-bottom: 35px;
}

.prestamo-vida-monto-mobile .disponible-hoy-icon {
  width: 40px;
  height: 40px;
  object-fit: contain;
  margin-right: 8px;
}

.prestamo-vida-monto-mobile .disponible-hoy-amount {
  color: #0855C4;
  font-size: 30px;
  line-height: 1;
}

.prestamo-vida-poliza-active {
  border: 1.5px solid #0855C4 !important;
}

/*
 * Peek track: misma izquierda que el bloque 356 centrado;
 * bleed a la derecha para el peek (Figma: card 363, bloque 356).
 */
.prestamo-vida-peek-track {
  display: flex;
  flex-wrap: nowrap;
  gap: 12px;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  box-sizing: border-box;
  width: calc(100% + 16px);
  margin-right: -16px;
  padding-left: max(0px, calc((100% - 356px) / 2));
  padding-right: 16px;
}

.prestamo-vida-peek-track::-webkit-scrollbar {
  display: none;
}

/* Figma ref. 414px: card 363x120 */
.prestamo-vida-peek-item {
  flex: 0 0 363px;
  width: 363px;
  height: 120px;
  max-width: none;
  scroll-snap-align: start;
  margin-bottom: 0;
  box-sizing: border-box;
}

/* Pantallas más angostas que el card de referencia */
@media only screen and (max-width: 390px) {
  .prestamo-vida-peek-item {
    flex: 0 0 calc(100% - 24px);
    width: calc(100% - 24px);
    height: 120px;
  }

  .prestamo-vida-monto-mobile .disponible-hoy-card {
    width: 100%;
    max-width: 356px;
  }
}

@media only screen and (max-width: 600px) {
  .inicio-main-dash {
    margin-top: 0 !important;
  }
}

/* Desktop: panel grande (lista + monto) | info derecha
   960px = breakpoint md de Vuetify (hidden-sm-and-down) */
@media only screen and (min-width: 960px) {
  .inicio-main-dash-prestamo-vida {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    width: 100%;
    min-height: 100vh;
    background: transparent;
  }

  .prestamo-vida-polizas-panel {
    flex: 1 1 auto;
    min-width: 0;
    margin-left: 10px;
    margin-right: 10px;
    padding: 25px 50px;
    background: #fff;
  }

  .prestamo-vida-panel-body {
    display: flex;
    align-items: flex-start;
    gap: 24px;
  }

  .prestamo-vida-lista {
    flex: 1 1 auto;
    min-width: 0;
  }

  /* Solo el párrafo de instrucción, alineado a la columna de cards */
  .prestamo-vida-lista > .text-instruction {
    margin-left: 0;
    padding-left: 0;
    max-width: 26rem;
  }

  .prestamo-vida-monto-panel {
    flex: 0 0 auto;
    width: 100%;
    max-width: 359px;
    background: #F1F1F1;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border: 1px solid #E2E8F0;
    padding: 24px;
  }

  /* Como Mis pagos: space-between + padding lateral; img fija a 214px */
  .inicio-main-dash-prestamo-vida > .inicio-extra {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
    margin-right: 0;
    padding: 0 50px !important;
    background: white;
    min-height: auto;
  }

  .inicio-main-dash-prestamo-vida > .inicio-extra img {
    width: 214px;
    max-width: 214px;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PrestamoVida.vue